export default [
  "#94c8f0",
  "#498cdc",
  "#4b5d89",
  "#f3c911",
  "#dc5a56",
  "#33ae81",
  "#e08e3b",
  "#5f537d",
  // "#85b4d8",
  // "#427ec6",
  // "#44547b",
  // "#dbb50f",
  // "#c6514d",
  // "#2e9d74",
  // "#ca8035",
  // "#564b71",
  // "#76a0c0",
  // "#3a70b0",
  // "#3c4a6e",
  // "#c2a10e",
  // "#b04845",
  // "#298b67",
  // "#b3722f",
  // "#4c4264",
  "#688ca8",
  "#33629a",
  "#354160",
  "#aa8d0c",
  "#9a3f3c",
  "#247a5a",
  "#9d6329",
  "#433a58",
  // "#597890",
  // "#2c5484",
  // "#2d3852",
  // "#92790a",
  // "#843634",
  // "#1f684d",
  // "#865523",
  // "#39324b",
  // "#4a6478",
  // "#25466e",
  // "#262f45",
  // "#7a6509",
  // "#6e2d2b",
  // "#1a5741",
  // "#70471e",
  // "#302a3f",
  "#3b5060",
  "#1d3858",
  "#1e2537",
  "#615007",
  "#582422",
  "#144634",
  "#5a3918",
  "#262132"
];
